import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  let user = null;
  try { user = JSON.parse(localStorage.getItem('user') || 'null'); } catch (_) {}
  if (!user || !user.id) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};

export default ProtectedRoute;
